import React, { useState } from 'react';

import CreditCardIframeContainer from './CreditCardIframeContainer';
import PaymentSessionRefreshModal from './PaymentSessionRefreshModal';
import { PaymentFormState } from './types';

interface CreditCardFormProps {
  onFormStateChange: (state: PaymentFormState) => void;
  onSubmitPayment: () => Promise<unknown>;
}

const CreditCardForm = ({ onFormStateChange, onSubmitPayment }: CreditCardFormProps) => {
  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);

  const handleContinue = () => {
    setRefreshModalOpen(false);
    setIframeKey((prev) => prev + 1); // trigger full iframe remount
  };

  const handleFormStateChange = (state: PaymentFormState) => {
    if (state.isExpired) {
      setRefreshModalOpen(true);
    }
    onFormStateChange(state);
  };

  return (
    <>
      <CreditCardIframeContainer
        key={iframeKey}
        onFormStateChange={handleFormStateChange}
        onSubmitPayment={onSubmitPayment}
      />
      <PaymentSessionRefreshModal open={refreshModalOpen} onContinue={handleContinue} />
    </>
  );
};

export default CreditCardForm;
